import ContactForm from "@/components/blocks/contact-us -form";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/contact-us")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <ContactForm />
    </>
  );
}
